<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1">
<p class="image"><img alt="" src="OEBPS/images/5-1.png"/></p>
<p class="pagebreak"> </p>
<p class="image"><img alt="" src="OEBPS/images/6-1.png"/></p>
<p class="pagebreak"> </p>
<p class="image1"><img alt="" src="OEBPS/images/7-1.png"/></p>
<p class="image1"><img alt="" src="OEBPS/images/8-1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm3.vue?5a21373e